/**
 * MegaRTL Blog JavaScript
 * Handles tag filtering for blog listing and interactions for article page
 */

document.addEventListener('DOMContentLoaded', () => {
    initBlogTagFilter();
    initArticleInteractions();
});

// Blog Listing Tag Filter
const initBlogTagFilter = () => {
    const tagButtons = document.querySelectorAll('.blog-tag');
    const blogCards = document.querySelectorAll('.blog-card');

    if (tagButtons.length === 0 || blogCards.length === 0) {
        return;
    }

    tagButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const selectedTag = button.getAttribute('data-tag');

            // Update active state
            tagButtons.forEach(btn => {
                btn.classList.remove('blog-tag--active');
            });
            button.classList.add('blog-tag--active');

            // Filter cards
            blogCards.forEach(card => {
                const cardTags = card.getAttribute('data-tags');

                if (selectedTag === 'all' || !selectedTag) {
                    // Show all cards
                    card.style.display = 'block';
                } else if (cardTags && cardTags.includes(selectedTag)) {
                    // Show matching cards
                    card.style.display = 'block';
                } else {
                    // Hide non-matching cards
                    card.style.display = 'none';
                }
            });
        });
    });
};

// Article Page Interactions
function initArticleInteractions() {
    const sections = document.querySelectorAll('.article-section');

    sections.forEach(section => {
        if (section._articleInitialized) return;
        section._articleInitialized = true;

        initLazyLoading(section);
        initImageHandling(section);
        initCommentForm(section);
    });
}

function initLazyLoading(section) {
    const images = section.querySelectorAll('.article-image-img[loading="lazy"]');

    if ('IntersectionObserver' in window && images.length > 0) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('loaded');
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '50px' });

        images.forEach(img => observer.observe(img));
    } else {
        images.forEach(img => img.classList.add('loaded'));
    }
}

function initImageHandling(section) {
    const images = section.querySelectorAll('.article-content img');

    images.forEach(img => {
        // Add loading attribute if not present
        if (!img.hasAttribute('loading')) {
            img.setAttribute('loading', 'lazy');
        }

        // Handle image errors
        img.addEventListener('error', function () {
            this.style.display = 'none';
        });
    });
}

function initCommentForm(section) {
    const form = section.querySelector('.article-comment-form');
    if (!form) return;

    // Add form validation feedback
    const inputs = form.querySelectorAll('input, textarea');
    inputs.forEach(input => {
        input.addEventListener('blur', function () {
            if (this.validity.valid) {
                this.classList.remove('error');
            } else {
                this.classList.add('error');
            }
        });

        input.addEventListener('input', function () {
            if (this.validity.valid) {
                this.classList.remove('error');
            }
        });
    });

    // Handle form submission
    form.addEventListener('submit', function (e) {
        const submitButton = form.querySelector('.article-comment-submit');
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = submitButton.textContent + '...';
        }
    });
}

// Shopify Theme Editor Support
document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.article-section');
    if (section) {
        section._articleInitialized = false;
        initArticleInteractions();
    }

    // Re-init blog filter if we are on blog page (less common to reload whole section but possible)
    if (document.querySelector('.blog-tag')) {
        initBlogTagFilter();
    }
});
